import { getWixConfigFilePath } from '@wix/cli-core-definitions';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { pathExists } from '@wix/cli-fs';
import { wixAstroConfigSchema } from '@wix/cli-astro-definitions';
import type { WixAstroConfig } from '@wix/cli-astro-definitions';
import { join } from 'node:path';
import type { DefineWixConfigOptions } from './types/wix-astro-config.js';

export const defineWixConfig = (
  options: DefineWixConfigOptions
): DefineWixConfigOptions => {
  return options;
};

export const DYNAMIC_WIX_CONFIG_FILENAME = 'wix.config.mjs';

interface ExistingWixConfigPaths {
  dynamicConfigPath?: string;
  legacyConfigPath?: string;
}

export const getExistingWixConfigPaths = async (
  projectFolder: string
): Promise<ExistingWixConfigPaths> => {
  const dynamicConfigPath = join(projectFolder, DYNAMIC_WIX_CONFIG_FILENAME);
  const legacyConfigPath = getWixConfigFilePath(projectFolder);

  const [dynamicConfigExists, legacyConfigExists] = await Promise.all([
    pathExists(dynamicConfigPath),
    pathExists(legacyConfigPath),
  ]);

  return {
    dynamicConfigPath: dynamicConfigExists ? dynamicConfigPath : undefined,
    legacyConfigPath: legacyConfigExists ? legacyConfigPath : undefined,
  };
};

export const validateWixConfig = (
  value: unknown,
  configPath: string
): WixAstroConfig => {
  const config = wixAstroConfigSchema.safeParse(value);

  if (config.success) {
    return config.data;
  }

  throw new CliError({
    code: CliErrorCode.InvalidConfigSchemaError({
      configPath,
      zodError: config.error,
    }),
    cause: config.error,
  });
};
